import { Link } from 'react-router-dom';
// Settings.jsx
import { useEffect, useState } from "react";
import { get, patchRequest } from "../http/api";
import "./Settings.css";

export default function Settings() {

  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await get("settings");
      setSettings(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    try {
      await patchRequest("settings", settings);
      alert("Paramètres mis à jour");
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <div className="settings-loading">Chargement...</div>;

  return (
    <div className="settings-container">

      <h2>Paramètres du compte</h2>
      <Link to="/billing">Premium / Billing</Link>

      {/* CONFIDENTIALITÉ */}
      <div className="settings-section">
        <h3>Confidentialité</h3>

        <div className="settings-item">
          <label>Visibilité du profil</label>
          <select
            value={settings.profile_visibility}
            onChange={(e) => handleChange("profile_visibility", e.target.value)}
          >
            <option value="public">Public</option>
            <option value="private">Privé</option>
          </select>
        </div>

        <div className="settings-item">
          <label>Qui peut m’envoyer un message ?</label>
          <select
            value={settings.message_permission}
            onChange={(e) => handleChange("message_permission", e.target.value)}
          >
            <option value="everyone">Tout le monde</option>
            <option value="connections">Connexions</option>
            <option value="mutual_follow">Followers mutuels</option>
          </select>
        </div>

        <div className="settings-item">
          <label>Qui peut voir mes followers ?</label>
          <select
            value={settings.followers_visibility}
            onChange={(e) => handleChange("followers_visibility", e.target.value)}
          >
            <option value="everyone">Tout le monde</option>
            <option value="connections">Connexions</option>
            <option value="only_me">Seulement moi</option>
          </select>
        </div>
      </div>

      {/* NOTIFICATIONS */}
      <div className="settings-section">
        <h3>Notifications</h3>

        <div className="settings-checkbox">
          <label>
            <input
              type="checkbox"
              checked={settings.notify_likes}
              onChange={(e) => handleChange("notify_likes", e.target.checked)}
            />
            Likes
          </label>
        </div>

        <div className="settings-checkbox">
          <label>
            <input
              type="checkbox"
              checked={settings.notify_comments}
              onChange={(e) => handleChange("notify_comments", e.target.checked)}
            />
            Commentaires
          </label>
        </div>

        <div className="settings-checkbox">
          <label>
            <input
              type="checkbox"
              checked={settings.notify_follows}
              onChange={(e) => handleChange("notify_follows", e.target.checked)}
            />
            Nouveaux followers
          </label>
        </div>

        <div className="settings-checkbox">
          <label>
            <input
              type="checkbox"
              checked={settings.notify_messages}
              onChange={(e) => handleChange("notify_messages", e.target.checked)}
            />
            Messages
          </label>
        </div>
      </div>

      {/* DANGER ZONE */}
      <div className="settings-section danger-zone">
        <h3>Zone sensible</h3>
        <button className="delete-account-btn">
          Supprimer mon compte
        </button>
      </div>

      <button className="save-btn" onClick={handleSave}>
        Enregistrer les modifications
      </button>

    </div>
  );
}
